export const SECOND = 1000
const MINUTE = 60 * SECOND
const HOUR = 60 * MINUTE
export const DAY = 24 * HOUR

export interface CountdownParts {
  days: number
  hours: number
  minutes: number
  seconds: number
  /** Milliseconds left, never negative. */
  remaining: number
}

/** Time left until `target`, split into whole units. Zero once it has passed. */
export function countdownParts(target: number, now: number): CountdownParts {
  const remaining = Math.max(0, target - now)
  return {
    days: Math.floor(remaining / DAY),
    hours: Math.floor((remaining % DAY) / HOUR),
    minutes: Math.floor((remaining % HOUR) / MINUTE),
    seconds: Math.floor((remaining % MINUTE) / SECOND),
    remaining,
  }
}

/**
 * The same time in words, at minute precision — what a screen reader is told.
 * Announcing every second would talk over everything else on the page.
 */
export function countdownLabel(p: CountdownParts): string {
  if (p.remaining === 0) return 'Time is up'
  const plural = (n: number, unit: string) => `${n} ${unit}${n === 1 ? '' : 's'}`
  const parts = [
    p.days > 0 && plural(p.days, 'day'),
    (p.days > 0 || p.hours > 0) && plural(p.hours, 'hour'),
    // Under a minute still reads as a minute, never "0 minutes left".
    plural(p.days === 0 && p.hours === 0 ? Math.max(1, p.minutes) : p.minutes, 'minute'),
  ].filter(Boolean)
  return `${parts.join(' ')} left`
}
